import { BACKEND_PRIVATE } from '@/api/base'

export async function addBookmark(payload: any) {
  return BACKEND_PRIVATE.post<LX.Bookmark>('/me/bookmarks/add', payload)
}

export async function removeBookmark(id: number) {
  return BACKEND_PRIVATE.delete(`/me/bookmarks/remove?id=${id}`)
}

export async function loadBookmarksVacancies(params: any) {
  return BACKEND_PRIVATE.get<LX.Paginated<{ bookmarks: LX.BookmarkListItem[] }>>('/me/bookmarks/list-vacancy', {
    params,
  })
}

export async function loadBookmarksJobs(params: any) {
  return BACKEND_PRIVATE.get<LX.Paginated<{ bookmarks: LX.BookmarkListItem[] }>>(`/me/bookmarks/list-jobs`, {
    params,
  })
}

export async function loadBookmarksGigs(params: any) {
  return BACKEND_PRIVATE.get<LX.Paginated<{ bookmarks: LX.BookmarkListItem[] }>>('/me/bookmarks/list-gigs', {
    params,
  })
}
